import { render, staticRenderFns } from "./BaseSearchBarNew.vue?vue&type=template&id=67e914de"
import script from "./BaseSearchBarNew.vue?vue&type=script&lang=js"
export * from "./BaseSearchBarNew.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchBarNew.vue?vue&type=style&index=0&id=67e914de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports